import type { CaseData } from '@/types/caseData';

export function formatSeconds(seconds: number | undefined): string {
  if (seconds === undefined) {
    return '0m';
  }

  if (seconds > 0) {
    seconds = seconds * 60;
  }

  const minutes = Math.floor(seconds / 60); // Calculate full minutes
  const remainingSeconds = seconds % 60; // Calculate leftover seconds

  if (remainingSeconds === 0) {
    return `${minutes}m`; // Show only minutes if no remaining seconds
  }
  return `${minutes}m ${remainingSeconds}s`;
}

export function formatBlockTime(seconds: number | undefined): string {
  if (seconds === undefined) {
    return '0 minutes';
  }

  if (seconds > 0) {
    seconds = seconds * 60;
  }

  const minutes = Math.floor(seconds / 60); // Calculate full minutes
  const remainingSeconds = seconds % 60; // Calculate leftover seconds

  if (remainingSeconds === 0) {
    return `${minutes} minutes`; // Show only minutes if no remaining seconds
  }
  return `${minutes} minutes ${remainingSeconds} seconds`;
}

export const duplicateCaseStudy = (data: CaseData, isTemplate: boolean = false) => {
  const api = useAPI();

  api(`/case-studies/${data.organizationId}/${data.id}?isTemplate=${isTemplate}`, {
    method: 'POST',
  }).then((data) => {
    const caseData = data as CaseData;
    if (isTemplate) {
      navigateTo(`/admin/case-templates/edit/${caseData.id}`);
    } else {
      navigateTo(`/admin/cases/edit/${caseData.id}`);
    }
  });
};

export const formattedMessage = (text: string) => {
  return text?.replace(/\n\n/g, '<br><br>') || '';
};

export const removeNbsp = (text: string) => {
  return text?.replace(/&nbsp;/g, ' ') || '';
};
